<template>
   <g>
      <path
         d="M2.02736 13H12.9726C13.1504 13 13.3251 12.9546 13.4797 12.8684C13.6343 12.7823 13.7635 12.6581 13.8547 12.5082C13.9458 12.3583 13.9958 12.1878 13.9997 12.0132C14.0037 11.8387 13.9615 11.6661 13.8772 11.5124L8.40488 1.53078C8.01666 0.823075 6.98334 0.823075 6.59512 1.53078L1.1228 11.5124C1.03853 11.6661 0.996302 11.8387 1.00025 12.0132C1.00421 12.1878 1.0542 12.3583 1.14535 12.5082C1.23649 12.6581 1.36568 12.7823 1.52027 12.8684C1.67487 12.9546 1.84959 13 2.02736 13Z"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M7.31653 5.08609L7.50085 8.93366L7.68484 5.08767C7.68598 5.06308 7.682 5.03853 7.67314 5.0155C7.66429 4.99248 7.65075 4.97147 7.63335 4.95376C7.61594 4.93605 7.59505 4.92201 7.57194 4.9125C7.54882 4.90299 7.52398 4.89821 7.49892 4.89845C7.4743 4.89868 7.44998 4.90376 7.42739 4.91338C7.4048 4.923 7.3844 4.93697 7.3674 4.95446C7.3504 4.97196 7.33714 4.99261 7.3284 5.01522C7.31967 5.03783 7.31563 5.06193 7.31653 5.08609Z"
         fill="white"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M7.55859 10.6982C7.58559 10.7092 7.60751 10.7277 7.62207 10.749C7.63655 10.7703 7.64355 10.7945 7.64355 10.8184C7.64353 10.85 7.631 10.882 7.60547 10.9072C7.57954 10.9327 7.54241 10.9491 7.50195 10.9492C7.47184 10.9492 7.44258 10.9403 7.41895 10.9248C7.39544 10.9094 7.37878 10.8881 7.36914 10.8652C7.35961 10.8426 7.3567 10.8183 7.36133 10.7949C7.36611 10.7713 7.37823 10.7474 7.39746 10.7285C7.41678 10.7096 7.44337 10.6962 7.47266 10.6904C7.5017 10.6848 7.53175 10.6874 7.55859 10.6982Z"
         fill="white"
         stroke="white"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-flags',
         viewBox: '0 0 15 14',
         width: 15,
         height: 14,
         fill: 'none',
      };
   },
};
</script>
